var getColorTheme = function getColorTheme(color) {
  switch (color) {
    case 'dark-core':
      return {
        bigPadColor: 'dark-core',
        smallPadColor: 'sunlight'
      };
    case 'rouge':
      return {
        bigPadColor: 'rouge',
        smallPadColor: 'sand'
      };
    case 'wave':
      return {
        bigPadColor: 'wave',
        smallPadColor: 'light-teal'
      };
    case 'olive':
      return {
        bigPadColor: 'olive',
        smallPadColor: 'light-olive'
      };
    case 'hazel':
      return {
        bigPadColor: 'hazel',
        smallPadColor: 'sand'
      };
    case 'almost-black':
      return {
        bigPadColor: 'almost-black',
        smallPadColor: 'white'
      };
    case 'latte':
      return {
        bigPadColor: 'latte',
        smallPadColor: 'sand'
      };
    case 'white':
      return {
        bigPadColor: 'white',
        smallPadColor: 'sand'
      };
    case 'sand':
      return {
        bigPadColor: 'sand',
        smallPadColor: 'white'
      };
    default:
      return {
        bigPadColor: 'dark-core',
        smallPadColor: 'sunlight'
      };
  }
};

export { getColorTheme };
//# sourceMappingURL=themes.js.map
